import { IKey, IMdCmFields, ISearchPageField } from "@src/types/FmsTypes";



/**
 * yh.auth.vo.marketingRecord.MarketingRecordDetail
 *
 * MarketingRecordDetail
 */
export interface IMarketingRecordFields extends IMdCmFields {
    /**
     * 分配金额
     */
    allocationAmount?: string;
    /**
     * 审批ID
     */
    approvalId?: string;
    auditInstanceList?: MarketingApproval[];
    /**
     * 业务联系人
     */
    businessContact?: string;
    /**
     * 业务联系人电话
     */
    businessContactPhone?: string;
    /**
     * 负责人
     */
    controller?: string;
    /**
     * 负责人电话
     */
    controllerPhone?: string;
    /**
     * 创建时间
     */
    createTime?: string;
    /**
     * 创建人
     */
    createUser?: string;
    /**
     * 创建人编码
     */
    createUserId?: string;
    /**
     * 当前审批人
     */
    currentApproverId?: string;
    /**
     * 当前审批人
     */
    currentApproverName?: string;
    /**
     * 客户ID
     */
    customerId?: string;
    /**
     * 客户名称
     */
    customerName?: string;
    /**
     * 决策者
     */
    decisionMaker?: string;
    /**
     * 决策者电话
     */
    decisionMakerPhone?: string;
    /**
     * 主键ID
     */
    id?: string;
    /**
     * 编码
     */
    proposalNo?: string;
    /**
     * 驳回人
     */
    rejectApproverId?: string;
    /**
     * 驳回人
     */
    rejectApproverName?: string;
    /**
     * 具体负责人
     */
    specificPerson?: string;
    /**
     * 状态 0:待提交 1:审批中 2:已通过 3:已驳回
     */
    status?: string;
    /**
     * 营销类型编码
     */
    typeCode?: string;
    /**
     * 营销类型名称
     */
    typeName?: string;
    /**
     * 更新时间
     */
    updateTime?: string;
    /**
     * 更新人
     */
    updateUser?: string;
    /**
     * 用户需求
     */
    userRequirement?: string;
    /**
     * 有效时间
     */
    validTime?: string;
    [property: string]: any;
}

/**
 * yh.auth.entity.MarketingApproval
 *
 * MarketingApproval
 */
export interface MarketingApproval {
    /**
     * 审批人ID
     */
    approverId?: string;
    /**
     * 审批人名称
     */
    approverName?: string;
    /**
     * 审批编号
     */
    code?: string;
    /**
     * 合同ID
     */
    contractId?: string;
    /**
     * 合同编号
     */
    contractNumber?: string;
    createTime?: string;
    createUser?: string;
    deleteFlag?: number;
    id?: string;
    /**
     * 是否历史记录 0:否 1:是
     */
    isHistory?: number;
    /**
     * 是否销售支持 0:否 1:是
     */
    isSupport?: number;
    /**
     * 审批名称
     */
    name?: string;
    /**
     * 审批意见
     */
    opinion?: string;
    orderNum?: number;
    /**
     * 处理时间
     */
    processTime?: string;
    /**
     * 驳回原因
     */
    rejectReason?: string;
    /**
     * 状态 0:待审批 1:审批通过 2:审批驳回
     */
    status?: string;
    traceId?: string;
    updateTime?: string;
    updateUser?: string;
    /**
     * 版本号
     */
    version: number;
    [property: string]: any;
}

export type IMarketingRecordDetail = IKey & IMarketingRecordFields;
export type IMarketingRecordSearch = IMarketingRecordFields & {pageSize?: number, pageNum?: number};



export const approvalProcessStatusEnum = {
	approvalProcessStatusUnapproved: 'unapproved',
	approvalProcessStatusApproved: 'approved',
	approvalProcessStatusDenied: 'denied',
	approvalProcessStatusSubmitted: 'submitted',
};

export const projectProposalStatusEnum = {
    projectProposalStatusPending: 'PENDING',
    projectProposalStatusReviewing: 'REVIEWING',
    projectProposalStatusFiled: 'FILED',
    projectProposalStatusRejected: 'REJECTED',
}

export const projectProposalStatusList = [
    {
        label: "待审批",
        value: projectProposalStatusEnum.projectProposalStatusPending
    },
    {
        label: "审批中",
        value: projectProposalStatusEnum.projectProposalStatusReviewing
    },
    {
        label: "已通过",
        value: projectProposalStatusEnum.projectProposalStatusFiled
    },
    {
        label: "已驳回",
        value: projectProposalStatusEnum.projectProposalStatusRejected
    },
]
